import { ReactComponent as TwitterIcon } from "../Assets/icons/twitter.svg";
import { ReactComponent as GithubIcon } from "../Assets/icons/github.svg";
import { ReactComponent as LinkedInIcon } from "../Assets/icons/linkedin.svg";

export const socialMediaLinks = [
  // { href: "https://twitter.com/farhad_dev", icon: TwitterIcon, alt: "twitter" },
  { href: "https://github.com/farhad-gh-dev", icon: GithubIcon, alt: "github" },
  {
    href: "https://www.linkedin.com/in/mohammad-hosein-gholami-462827221",
    icon: LinkedInIcon,
    alt: "linked in",
  },
];

export const navbarLinks = [
  { title: "Skills", href: "#skills" },
  { title: "Projects", href: "#projects" },
  { title: "About", href: "#about" },
  { title: "Contact", href: "#contact" },
];
